import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { Navbar } from '../../src/components/Navbar';
import { LoginForm } from '../../src/components/LoginForm';
import { requestLogin as requestLoginAction } from '../../src/state/actions';
import { getPathNameFromUrl, getQuery, handleFeedback } from '../../src/utils/helpers';
import { identifyLoggedInUser } from '../../src/utils/segmentAnalytics';
import authService from '../../src/services/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Login = function Login(_ref) {
  var props = _extends({}, _ref);

  var router = useRouter();
  var _router$query = router.query,
      sso = _router$query.sso,
      redirect = _router$query.redirect,
      companyID = _router$query.companyID;
  sso = getQuery(sso);
  redirect = getQuery(redirect);
  companyID = getQuery(companyID);
  var redirectsToBookingPage = getPathNameFromUrl(redirect).indexOf('/booking/confirm') > -1;
  var loading = props.loading,
      requestLogin = props.requestLogin;

  var handleLogin = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email, impersonate) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestLogin({
                email: email,
                redirect: getRedirectURL(),
                impersonate: impersonate
              }).then(function (auth) {
                return auth && identifyLoggedInUser(auth.user);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLogin(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var generateCannyRedirect = function generateCannyRedirect() {
    if (redirect.indexOf('https://') !== 0 || !companyID) {
      return null;
    }

    return 'https://canny.io/api/redirects/sso?companyID=' + "".concat(companyID).concat(encodeURIComponent('&'), "redirect=").concat(redirect);
  };

  if (props.isLoggedIn && sso) {
    var redirectURL = generateCannyRedirect();
    authService.generateCannySSO().then(function (cannyToken) {
      location.assign("".concat(decodeURIComponent(redirectURL), "&ssoToken=").concat(cannyToken));
      handleFeedback(null, 'Redirecting to Canny...');
    });
  }

  var getRedirectURL = function getRedirectURL() {
    if (sso === 'canny') {
      return generateCannyRedirect();
    }

    return redirect;
  };

  var onSignUpLinkClick = function onSignUpLinkClick() {
    var redirectUrl = '/signup';

    if (redirect) {
      redirectUrl += "?redirect=".concat(encodeURIComponent(getQuery(redirect)));
    }

    router.push(redirectUrl);
  };

  if (props.loginRequestSent) {
    router.push('/confirm-email');
  }

  return /*#__PURE__*/_jsxs("div", {
    className: "fit mx-auto h-fill flex flex-column max-w-full lg:max-w-screen-xl lg:mx-auto",
    children: [/*#__PURE__*/_jsx(Navbar, {
      brandProps: {
        // eslint-disable-next-line
        onClick: function onClick() {}
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "fit flex flex-auto overflow-auto prospect-container",
      children: [/*#__PURE__*/_jsx(Head, {
        children: /*#__PURE__*/_jsx("title", {
          children: "Subkit | Login"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classNames('flex flex-column prospect-page-container w-fill md:w-1/2'),
        children: /*#__PURE__*/_jsx("div", {
          className: classNames('px2 flex flex-column prospect-page-left-wrapper flex-auto justify-center lg:w-3/4'),
          children: /*#__PURE__*/_jsx(LoginForm, {
            showSignUpLink: redirectsToBookingPage,
            onSignUpLinkClick: onSignUpLinkClick,
            loading: loading,
            login: handleLogin
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classNames('prospect-page-right-wrapper email-not-sent lg:flex lg:flex-auto lg:justify-center'),
        children: /*#__PURE__*/_jsx("img", {
          src: "https://subkit-images.s3.amazonaws.com/images/woman-laptop.svg",
          alt: "Woman with laptop",
          className: "illustration"
        })
      })]
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users;

  return {
    loading: state.auth.loading,
    isLoggedIn: !!((_state$auth$users = state.auth.users) !== null && _state$auth$users !== void 0 && _state$auth$users.current),
    currentUser: state.auth.users.current,
    loginRequestSent: state.auth.loginRequestSent
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestLogin: function requestLogin(payload) {
      return dispatch(requestLoginAction(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);